import Counter from "../Counter";
import { PROOF_ORGS } from "../../data/content";

/**
 * Credibility strip — animated count-up on scroll, static fallback for
 * screen readers / reduced motion / no-JS. Compact list of approved orgs.
 */
export default function CredibilityStrip() {
  return (
    <section
      data-testid="credibility-strip"
      className="ground-paper sec-pad-tight border-t border-[color:var(--line-soft)]"
    >
      <div className="wrap">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          {/* 10+ years */}
          <div data-testid="credibility-item-0">
            <div
              className="font-hook-black text-[#0E1330]"
              style={{ fontSize: "clamp(30px, 3.4vw, 44px)", lineHeight: 1.02, letterSpacing: "-0.015em" }}
            >
              <Counter value={10} suffix="+" unit=" years" ariaFinal="10+ years" />
            </div>
            <p className="font-body-serif text-[#383D5A] mt-2" style={{ fontSize: 15 }}>
              In learning and development
            </p>
          </div>

          {/* 90,000+ */}
          <div
            data-testid="credibility-item-1"
            className="md:border-l md:border-[color:var(--line-soft)] md:pl-8"
          >
            <div
              className="font-hook-black text-[#0E1330]"
              style={{ fontSize: "clamp(30px, 3.4vw, 44px)", lineHeight: 1.02, letterSpacing: "-0.015em" }}
            >
              <Counter value={90000} suffix="+" ariaFinal="90,000+" />
            </div>
            <p className="font-body-serif text-[#383D5A] mt-2" style={{ fontSize: 15 }}>
              Learners reached
            </p>
          </div>

          {/* 30+ */}
          <div
            data-testid="credibility-item-2"
            className="md:border-l md:border-[color:var(--line-soft)] md:pl-8"
          >
            <div
              className="font-hook-black text-[#0E1330]"
              style={{ fontSize: "clamp(30px, 3.4vw, 44px)", lineHeight: 1.02, letterSpacing: "-0.015em" }}
            >
              <Counter value={30} suffix="+" ariaFinal="30+" />
            </div>
            <p className="font-body-serif text-[#383D5A] mt-2" style={{ fontSize: 15 }}>
              Organisations and institutions
            </p>
          </div>
        </div>

        {/* Screen-reader friendly text list (kept inline so a11y still gets clean org names) */}
        <ul
          data-testid="proof-orgs"
          className="sr-only"
        >
          {PROOF_ORGS.map((o) => (<li key={o.name}>{o.name}</li>))}
        </ul>
      </div>
    </section>
  );
}
